class BulkForm extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll("input[type='number']");
    this.totalPrice = this.querySelector(".bulk-order-total");
    this.submit = this.querySelector("button[type='submit']");
    this.qtySpan = this.querySelector(".bulk-qty-total");

    this.inputs.forEach((input) => {
      input.addEventListener("input", () => {
        this.updateTotals();
      });
    });

    this.submit.addEventListener("click", this.submitForm.bind(this));
  }

  submitForm() {
    let formData = {
      items: [],
    };

    const options = {
      firstCallback: function (requestState) {},
      lastCallback: function (requestState) {},
      info: {},
    };

    this.inputs.forEach((input) => {
      if (input.value > 0) {
        formData.items.push({
          id: input.dataset.id,
          quantity: parseFloat(input.value),
        });
      }
    });
    const body = {
      items: formData.items,
    };

    window.liquidAjaxCart.add(body, options);
  }

  updateTotals() {
    let total = 0;
    let qty = 0;
    this.inputs.forEach((input) => {
      if (input.value) {
        const max = parseFloat(input.dataset.max) || 1000;
        const management = input.dataset.management;
        if (parseFloat(input.value) > max && management === "shopify") {
          input.value = max;
        }
        total += parseFloat(input.value) * parseFloat(input.dataset.price);
        qty += parseFloat(input.value);
      }
    });
    this.totalPrice.textContent = `${window.Moonbase.currency}${total.toFixed(
      2
    )}`;
    this.qtySpan.textContent = qty;
  }
}

customElements.define("product-bulk-order-form", BulkForm);
